module.exports = __webpack_public_path__ + "static/media/nlp.c216620b.svg";